import { Pencil, Trash2 } from 'lucide-react';
import type { Company } from '../../types/api';
import { formatCNPJ, formatPhone } from '../../types/api';
import { DataTable } from '../ui';

interface CompanyListProps {
  companies: Company[];
  onEdit: (company: Company) => void;
  onDelete: (company: Company) => void;
}

function CompanyList({ companies, onEdit, onDelete }: CompanyListProps) {
  const columns = [
    {
      header: 'CNPJ',
      accessorKey: 'cnpj' as const,
      cell: (row: Company) => formatCNPJ(row.cnpj),
      className: 'whitespace-nowrap',
    },
    {
      header: 'Nome',
      accessorKey: 'company_name' as const,
    },
    {
      header: 'Endereço',
      accessorKey: 'address' as const,
      cell: (row: Company) => row.address || '-',
    },
    {
      header: 'Cidade',
      accessorKey: 'city' as const,
      cell: (row: Company) => row.city || '-',
    },
    {
      header: 'Telefone',
      accessorKey: 'phone' as const,
      cell: (row: Company) => (row.phone ? formatPhone(row.phone) : '-'),
      className: 'whitespace-nowrap',
    },
    {
      header: 'Email',
      accessorKey: 'email' as const,
      cell: (row: Company) => row.email || '-',
    },
  ];

  return <DataTable columns={columns} data={companies} onEdit={onEdit} onDelete={onDelete} />;
}

export default CompanyList;
